const awsmobile = {
    "aws_appsync_graphqlEndpoint": "https://kdusrnea55cqnb63prczl5rtzq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-677kf5iwuzebpkijfkt5fv4h64",
};
export default awsmobile;
